import { type CategorySlugsToCategoryIds } from '#app/types/blogs.js';

/**
 * These map directly to IDs for BlogCategory types in the DB.
 * Use the blogCategories {} query in the API to get an updated list.
 */
// cSpell:ignore Wdvcnki
export const CATEGORY_SLUG_MAP: CategorySlugsToCategoryIds = {
  'ai-and-the-future-of-work': 'WyJCbG9nQ2F0ZWdvcnkiLDE5XQ==',
  community: 'WyJCbG9nQ2F0ZWdvcnkiLDdd',
  content: 'WyJCbG9nQ2F0ZWdvcnkiLDNd',
  design: 'WyJCbG9nQ2F0ZWdvcnkiLDJd',
  'design-and-creative': 'WyJCbG9nQ2F0ZWdvcnkiLDE0XQ==',
  engineering: 'WyJCbG9nQ2F0ZWdvcnkiLDRd',
  'engineering-dev-and-it': 'WyJCbG9nQ2F0ZWdvcnkiLDE1XQ==',
  'ethics-and-ai': 'WyJCbG9nQ2F0ZWdvcnkiLDIxXQ==',
  'for-clients': 'WyJCbG9nQ2F0ZWdvcnkiLDld',
  'for-independents': 'WyJCbG9nQ2F0ZWdvcnkiLDhd',
  hiring: 'WyJCbG9nQ2F0ZWdvcnkiLDFd',
  'how-to': 'WyJCbG9nQ2F0ZWdvcnkiLDE4XQ==',
  marketing: 'WyJCbG9nQ2F0ZWdvcnkiLDE3XQ==',
  news: 'WyJCbG9nQ2F0ZWdvcnkiLDZd',
  newsroom: 'WyJCbG9nQ2F0ZWdvcnkiLDZd',
  'remote-working-and-freelancing': 'WyJCbG9nQ2F0ZWdvcnkiLDEwXQ==',
  'social-media': 'WyJCbG9nQ2F0ZWdvcnkiLDE2XQ==',
  'success-stories': 'WyJCbG9nQ2F0ZWdvcnkiLDEyXQ==',
  tips: 'WyJCbG9nQ2F0ZWdvcnkiLDVd',
  'tips-for-hiring': 'WyJCbG9nQ2F0ZWdvcnkiLDExXQ==',
  'tools-software-and-programming-languages': 'WyJCbG9nQ2F0ZWdvcnkiLDIwXQ==',
  trends: 'WyJCbG9nQ2F0ZWdvcnkiLDIyXQ==',
  writing: 'WyJCbG9nQ2F0ZWdvcnkiLDEzXQ==',
};

export const BLOG_CATEGORIES_MAX = 4;
